module.exports = __webpack_public_path__ + "fonts/db_helvethaicaais_x_v3.2-webfont.8454b076.ttf";